/**
 * @file 线索规则匹配组件
 * @author fightingliu
 * @create 2022.09.13
 * @modify 2022.09.13
 */
import React from 'react';
import { Input, Select } from '@tencent/spaui';
import '../../../../../../style/less/pages/recycle.less';
import './index.less';

export default (props) => {
  const {
    data = {},
    onChange,
    actionOptions,
    isEditing = false,
  } = props;

  const { dulltime, action } = data;

  const handleDullTimeChange = (e, value) => {
    let newValue = value;
    if (parseInt(value, 10) > 100) return;
    if (parseInt(value) < 0) return;
    onChange?.({
      dulltime: newValue,
      action,
      ...(value === 'STRING' && ({ value: '' })),
    });
  };
  const handleOnFocusOut = (e) => {
    let newValue = dulltime;
    if (!/^(?!0$)\d+(?:[,.][05])?$/.test(dulltime)) {
      newValue = Math.round(dulltime*2)/2;
    };
    if (newValue === 0) {
      newValue = 0.5;
    }
    onChange?.({
      dulltime: newValue,
      action,
    });
  };
  const handleActionChange = (e, value) => {
    onChange?.({ ...data, action: value });
  };

  return (
    <div className="leads-recycle-content-sub">
      <span>分配给客服的线索</span>
      <Input
        type="number"
        value={dulltime}
        onChange={handleDullTimeChange}
        onBlur={handleOnFocusOut}
        style={{ width: 80 }}
        disabled={!isEditing}
        data-testid="dull"
        step={0.5}
      />
      <span>小时后，客服仍未</span>
      <Select
        data={actionOptions}
        value={action}
        onChange={handleActionChange}
        style={{ width: 260 }}
        disabled={!isEditing}
        data-testid="action"
      />
      <span>，线索自动回收至公海池</span>
    </div>
  );
};
